// Utility helpers for OrderItemVertical enum to human-readable strings.
// Centralizes mapping to keep UI consistent across the app.

import * as common_pb from 'respona_api/generated/common_pb';

/**
 * Map a single OrderItemVertical enum value to its display string.
 */
export function orderItemVerticalToString(
  value: common_pb.OrderItemVerticalMap[keyof common_pb.OrderItemVerticalMap]
): string {
  switch (value) {
    case common_pb.OrderItemVertical.UNDEFINED_VERTICAL:
      return 'Any Topic';
    case common_pb.OrderItemVertical.AI_AND_DATA_SCIENCE:
      return 'AI & Data Science';
    case common_pb.OrderItemVertical.COMPUTERS_AND_HARDWARE:
      return 'Computer Hardware';
    case common_pb.OrderItemVertical.SOFTWARE_AND_APPS:
      return 'Software & Applications';
    case common_pb.OrderItemVertical.PROGRAMMING_AND_DEVELOPMENT:
      return 'Programming & Development';
    case common_pb.OrderItemVertical.E_COMMERCE_AND_ONLINE_BUSINESS:
      return 'E-Commerce Business';
    case common_pb.OrderItemVertical.MARKETING_AND_ADVERTISING:
      return 'Marketing & Advertising';
    case common_pb.OrderItemVertical.BUSINESS_AND_ENTREPRENEURSHIP:
      return 'Business & Startups';
    case common_pb.OrderItemVertical.FINANCE_AND_BANKING:
      return 'Finance & Banking';
    case common_pb.OrderItemVertical.CAREER_AND_EMPLOYMENT:
      return 'Careers & Jobs';
    case common_pb.OrderItemVertical.EDUCATION_AND_LEARNING:
      return 'Education & Learning';
    case common_pb.OrderItemVertical.REAL_ESTATE_AND_PROPERTY:
      return 'Real Estate & Property';
    case common_pb.OrderItemVertical.LAW_AND_LEGAL:
      return 'Law & Legal Matters';
    case common_pb.OrderItemVertical.PUBLIC_SECTOR_AND_POLITICS:
      return 'Government & Politics';
    case common_pb.OrderItemVertical.LIFESTYLE_AND_CULTURE:
      return 'Lifestyle & Culture';
    case common_pb.OrderItemVertical.FAMILY_AND_RELATIONSHIPS:
      return 'Family & Relationships';
    case common_pb.OrderItemVertical.FOR_WOMEN:
      return 'Women’s Topics';
    case common_pb.OrderItemVertical.FOR_MEN:
      return 'Men’s Topics';
    case common_pb.OrderItemVertical.HEALTH_AND_WELLNESS:
      return 'Health & Wellness';
    case common_pb.OrderItemVertical.BEAUTY_AND_FASHION:
      return 'Beauty & Fashion';
    case common_pb.OrderItemVertical.FOOD_AND_BEVERAGE:
      return 'Food & Beverages';
    case common_pb.OrderItemVertical.TRAVEL_AND_TOURISM:
      return 'Travel & Tourism';
    case common_pb.OrderItemVertical.HOME_AND_GARDEN:
      return 'Home & Garden';
    case common_pb.OrderItemVertical.ENTERTAINMENT_AND_MEDIA:
      return 'Entertainment & Media';
    case common_pb.OrderItemVertical.MUSIC_AND_ART:
      return 'Music & Arts';
    case common_pb.OrderItemVertical.PHOTOGRAPHY_AND_VISUAL_ARTS:
      return 'Photography & Visual Arts';
    case common_pb.OrderItemVertical.SPORTS_AND_OUTDOORS:
      return 'Sports & Outdoor Activities';
    case common_pb.OrderItemVertical.NATURE_AND_ENVIRONMENT:
      return 'Nature & Environment';
    case common_pb.OrderItemVertical.RELIGION_AND_SPIRITUALITY:
      return 'Religion & Spirituality';
    case common_pb.OrderItemVertical.NEWS_AND_SOCIETY:
      return 'News & Society';
    case common_pb.OrderItemVertical.AUTOMOTIVE_AND_TRANSPORTATION:
      return 'Automotive & Transport';
    case common_pb.OrderItemVertical.CONSTRUCTION_AND_ENGINEERING:
      return 'Construction & Engineering';
    case common_pb.OrderItemVertical.CRYPTOCURRENCY_AND_BLOCKCHAIN:
      return 'Cryptocurrency & Blockchain';
    case common_pb.OrderItemVertical.GAMING:
      return 'Video Gaming';
    case common_pb.OrderItemVertical.GAMBLING_AND_BETTING:
      return 'Gambling & Betting';
    case common_pb.OrderItemVertical.ADULT_SEX:
      return 'Adult Content';
    case common_pb.OrderItemVertical.VAPING_AND_TOBACCO:
      return 'Vaping & Tobacco';
    case common_pb.OrderItemVertical.MISCELLANEOUS_OTHER_NICHES:
      return 'Miscellaneous niches';
    default:
      return 'Unknown';
  }
}
